<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { useBillingStore } from '@/stores/BillingStore'

const billingStore = useBillingStore();
</script>
<template>
  <section class="mt-12 pb-8 xl:pb-16">
    <h2 class="text-xl md:text-2xl xl:text-3xl leading-tight font-semibold text-center mb-6">
      Frequently asked questions
    </h2>

    <Disclosure
      v-for="option in billingStore.plansFaq"
      :key="option.key"
      v-slot="{ open }"
      as="div"
      class="border-b"
    >
      <DisclosureButton class="flex items-center justify-between w-full py-4">
        <span v-text="option.question" class="text-left" />
        <Icon
          icon="heroicons:chevron-down-20-solid"
          class="text-xl text-gray-600 transition-all"
          :class="open ? 'rotate-180' : 'rotate-0'"
        />
      </DisclosureButton>
      <div
        class="grid transition-[grid-template-rows] duration-200 ease-out"
        :class="open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'"
      >
        <DisclosurePanel static class="overflow-hidden text-gray-500">
          <p v-text="option.answer" class="pb-4" />
        </DisclosurePanel>
      </div>
    </Disclosure>
  </section>
</template>